export default {
    listagem: {
        titulo_pagina: 'Settings for Generic Protocols',
        novo: 'Create New Configuration',
        table: {
            empty: 'No Configuration Found',
            nome: 'Name',
            metodo: 'Method',
            ordem_url: 'Url to process Order',
            resultado_url: 'Url to process Result',
            busca_resultado_url: 'Endpoint for Result',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Configuration',
            editar: 'Edit Configuration'
        },
        fields: {
            nome: {
                label: 'Name',
                description: 'Configuration Name'
            },
            metodo: {
                label: 'Method',
                description: 'Method executed by protocol'
            },
            ordem_url: {
                label: 'Url to process order',
                description: 'Url where the order and label will be extracted'
            },
            resultado_url: {
                label: 'Url to process result',
                description: 'Url where the result will be extracted'
            },
            busca_resultado_url: {
                label: 'Endpoint for search results',
                description: 'It will be filled in, if it is different from the default url of the integration'
            },
            tipo_conteudo: {
                label: 'Content-type',
                description: 'Padding for custom content-type'
            },
            botao_salvar : 'Save Configuration'
        },
        create: {
            success: 'Configuration created successfully!',
            error: 'Error creating configuration!'
        },
        update: {
            success: 'Configuration successfully edited!',
            error: 'Error editing configuration!'
        }
    }
}
